import React, {useEffect, useState} from 'react';
import './SorterLimiter.css';
import useBookListStore from "../../store/bookListStore";
import {useParams, useSearchParams} from "react-router-dom";
import {GetAllSearchParams} from "../../utilities/GetAllSearchParams";
import {ISortPoles} from "../../models/advanseFilter";
import {parseSortPoles} from "../../utilities/parseSortPoles";

interface SortLimiterProps {
    totalCount:number | null
}


const SorterLimiter = (props:SortLimiterProps) => {

    const [searchParams,setSearchParams] = useSearchParams();
    const [currentLimit,setCurrentLimit] = useState(searchParams.has('limit') ? searchParams.get('limit') : '5');
    const [currentSortPoles,setCurrentSortPoles] = useState<ISortPoles>(parseSortPoles(searchParams.get('sort') ?? null));



    const setLimit = (limit:string) => {
         const params = GetAllSearchParams(searchParams);
         setSearchParams({...params,limit});
    }

    useEffect(()=>{
        setCurrentLimit(searchParams.has('limit') ? searchParams.get('limit') : '5');
        setCurrentSortPoles(parseSortPoles(searchParams.get('sort') ?? null));
    },[searchParams])


    return (
        <div className={"sorter-limiter"}>
            <div className={"sorter-limiter__sorter btn-group"}>
                <div onClick={()=>setLimit('5')} className={`btn btn-outline-primary ${currentLimit === '5' ? 'active' : ''}`}>
                    5
                </div>
                <div onClick={()=>setLimit('10')} className={`btn btn-outline-primary ${currentLimit === '10' ? 'active' : ''}`}>
                    10
                </div>
                <div onClick={()=>setLimit('15')} className={`btn btn-outline-primary ${currentLimit === '15' ? 'active' : ''}`}>
                    15
                </div>
            </div>
            <div className={"sorter-limiter__text"}>
                {props.totalCount ? `Кол-во документов: ${props.totalCount}` : ''}
            </div>
            <div className={"sorter-limiter__sorter btn-group"}>
                <div className={"btn btn-outline-primary active"}>
                    <i id="sort-title" className="bi bi-sort-alpha-down"></i>
                </div>
                <div className={"btn btn-outline-primary"}>
                    <i id="sort-title" className="bi bi-sort-numeric-down"></i>
                </div>
            </div>
        </div>
    );
};

export default SorterLimiter;